import { Spin, Tag, Typography, Divider } from "antd";
import { AppstoreOutlined, DollarOutlined } from "@ant-design/icons";
import { fmt } from "./tenantPackageHelpers";

const { Text } = Typography;

interface Props {
  isLoading: boolean;
  current: any;
  currentPackageId: string | undefined;
  base: number;
  additional: number;
  total: number;
}

export const PackageCurrentPlan: React.FC<Props> = ({
  isLoading,
  current,
  currentPackageId,
  base,
  additional,
  total,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-32">
        <Spin tip="Loading package..." />
      </div>
    );
  }

  return (
    <div className="bg-slate-50 p-4 rounded-xl border border-slate-200">
      <div className="flex items-center gap-2 mb-3">
        <AppstoreOutlined className="text-purple-500" />
        <Text strong className="text-sm">
          Current Plan
        </Text>
      </div>
      {currentPackageId ? (
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <Text className="text-base font-semibold">
              {current?.package_name}
            </Text>
            <Tag color="purple" bordered={false}>
              {fmt(base)}
            </Tag>
          </div>
          <Text type="secondary" className="text-xs">
            Assigned:{" "}
            {current?.assigned_at
              ? new Date(current.assigned_at).toLocaleDateString()
              : "-"}
          </Text>

          <Divider className="!my-2" />

          <div className="flex flex-col gap-1 text-xs">
            <div className="flex justify-between">
              <Text type="secondary">Base plan price</Text>
              <Text strong>{fmt(base)}</Text>
            </div>
            <div className="flex justify-between">
              <Text type="secondary">Additional (extra features)</Text>
              <Text strong className={additional ? "text-amber-600" : ""}>
                {fmt(additional)}
              </Text>
            </div>
            <div className="flex justify-between border-t pt-1 mt-1">
              <Text strong>Total monthly cost</Text>
              <Text strong className="text-green-700">
                <DollarOutlined /> {fmt(total)}
              </Text>
            </div>
          </div>
        </div>
      ) : (
        <Text type="secondary" className="text-sm">
          No package assigned. The tenant has all features enabled by default
          and no plan billing.
        </Text>
      )}
    </div>
  );
};
